import { acceptHMRUpdate, defineStore } from "pinia";
import { ref } from "vue";
import { createStateApi } from "#/decision_tree_viewer/api/state";

const api = createStateApi();

export const useStateStore = defineStore("state", () => {
  const states = ref(null);

  async function load() {
    states.value = await api.all();
  }

  return {
    // state
    states,

    // actions
    load,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useStateStore, import.meta.hot));
}
